import React, { useEffect } from 'react';
import { useParams } from 'react-router';
// import { useMutation } from 'react-query';

import {ArrowTopRightIcon, IconButton, Link, Spinner, Table, TrashIcon, TagIcon, MenuIcon, StarIcon, RefreshIcon} from 'evergreen-ui';

// MutationResult
import {QueryResult, useMutation, useQuery} from '@apollo/client';

import { DELETE_FOOTPRINT, GET_FOOTPRINTS } from '../../helper/gql';
import { Footprint } from '../../interface';

// Date formatting utility
const formatDate = (dateString: string | Date) => {
  const date = new Date(dateString);
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }
  
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  
  // Relative time for recent dates
  if (seconds < 60) {
    return 'Just now';
  } else if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  } else if (hours < 24) {
    return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  } else if (days < 7) {
    return `${days} day${days === 1 ? '' : 's'} ago`;
  }
  
  // Absolute date for older entries
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};


function Footprints() {
  const { loading, error, data, refetch }: QueryResult<{ footprints: Footprint[] }> = useQuery(GET_FOOTPRINTS);
  // MutationResult<{ ... }>
  const [mutateFootprintDelete, mutateResult] = useMutation(DELETE_FOOTPRINT);
  const { token } = useParams<{ token: string }>();
  console.log(`Footprints() - token:`, token);
  useEffect(() => {
    console.log(`Footprints() - useEffect()`);
  });
  if (loading) return <Spinner size={24} />;
  if (error || !data) {
    console.log(`Footprints() - error:`, error);
    console.log(`Footprints() - data:`, data);
  }
  function deleteFootprint(footprintId: string) {
    console.log(`deleteFootprint() - footprintId:`, footprintId);
    console.log(`deleteFootprint() - token:`, token);
    console.log(`deleteFootprint() - mutateResult:`, mutateResult);
    mutateFootprintDelete({ variables: { footprintId } })
      .then((data) => {
        console.log(`mutateFootprintDelete() - data:`, data);
        console.log(`mutateFootprintDelete() - mutateResult:`, mutateResult);
        refetch();
      })
      .catch((reason) => {
        console.log(`mutateFootprintDelete() - reason:`, reason);
      });
  }
  if (!data?.footprints || data.footprints.length === 0) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '3rem',
        color: '#666',
        background: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #e1e5e9'
      }}>
        <h3 style={{ color: '#333', marginBottom: '1rem' }}>No footprints found</h3>
        <p>Start browsing to see your website footprints here.</p>
      </div>
    );
  }

  return (
    <div style={{ background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center', 
        padding: '12px 16px',
        borderBottom: '1px solid #e1e5e9',
        background: '#f8f9fa'
      }}>
        <IconButton 
          icon={RefreshIcon} 
          onClick={() => refetch()}
          title="Refresh footprints"
        />
      </div>
      <Table width="100%" style={{ tableLayout: 'fixed' }}>
        <Table.Head>
          <Table.TextHeaderCell 
            flexBasis={160} 
            flexShrink={0} 
            flexGrow={0}
            style={{ 
              fontWeight: 600, 
              color: '#333',
              background: '#f8f9fa',
              borderBottom: '2px solid #e1e5e9',
              width: '160px'
            }}
          >
            Date
          </Table.TextHeaderCell>
          <Table.TextHeaderCell 
            style={{ 
              fontWeight: 600, 
              color: '#333',
              background: '#f8f9fa',
              borderBottom: '2px solid #e1e5e9',
              width: 'calc(60% - 80px)'
            }}
          >
            URL
          </Table.TextHeaderCell>
          <Table.TextHeaderCell 
            style={{ 
              fontWeight: 600, 
              color: '#333',
              background: '#f8f9fa',
              borderBottom: '2px solid #e1e5e9',
              width: 'calc(40% - 80px)'
            }}
          >
            Title
          </Table.TextHeaderCell>
          <Table.TextHeaderCell 
            flexBasis={160} 
            flexShrink={0} 
            flexGrow={0}
            style={{ 
              fontWeight: 600, 
              color: '#333',
              background: '#f8f9fa',
              borderBottom: '2px solid #e1e5e9',
              width: '160px'
            }}
          >
            Actions
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.Body>
          {data.footprints.map((footprint) => (
            <Table.Row 
              key={footprint.id} 
              isSelectable 
              onSelect={() => console.log(footprint.url)}
              style={{ 
                borderBottom: '1px solid #e8e8e8',
                transition: 'background-color 0.2s ease'
              }}
            >
              <Table.TextCell 
                flexBasis={160} 
                flexShrink={0} 
                flexGrow={0}
                style={{ 
                  color: '#666',
                  fontSize: '0.9rem',
                  fontWeight: 500,
                  width: '160px'
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: 600, color: '#333' }}>
                    {formatDate(footprint.createdAt)}
                  </span>
                  <span style={{ fontSize: '0.8rem', color: '#999', marginTop: '2px' }}>
                    {new Date(footprint.createdAt).toLocaleString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
              </Table.TextCell>
              
              <Table.TextCell style={{ 
                color: '#667eea', 
                fontWeight: 500,
                width: 'calc(60% - 80px)',
                overflow: 'hidden'
              }}>
                <div style={{ 
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  <Link 
                    href={footprint.url} 
                    target="_blank"
                    style={{ 
                      color: '#667eea', 
                      textDecoration: 'none',
                      fontWeight: 600,
                      fontSize: '0.95rem'
                    }}
                    onMouseEnter={(e: any) => e.target.style.textDecoration = 'underline'}
                    onMouseLeave={(e: any) => e.target.style.textDecoration = 'none'}
                    title={footprint.url}
                  >
                    {footprint.url}
                  </Link>
                </div>
              </Table.TextCell>
              
              <Table.TextCell style={{ 
                width: 'calc(40% - 80px)',
                overflow: 'hidden'
              }}>
                <div style={{
                  color: footprint.title ? '#333' : '#999',
                  fontStyle: footprint.title ? 'normal' : 'italic',
                  fontWeight: footprint.title ? '500' : '400',
                  lineHeight: '1.4',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }} title={footprint.title || 'No title available'}>
                  {footprint.title || 'No title available'}
                </div>
              </Table.TextCell>
              
              <Table.TextCell 
                flexBasis={160} 
                flexShrink={0} 
                flexGrow={0}
                style={{ width: '160px' }}
              >
                <div style={{ 
                  display: 'flex', 
                  gap: '2px', 
                  alignItems: 'center', 
                  flexWrap: 'nowrap',
                  justifyContent: 'flex-start'
                }}>
                  <IconButton 
                    icon={TagIcon} 
                    onClick={(e: any) => {
                      e.stopPropagation();
                      console.log('Add tags:', footprint.id);
                    }}
                    title="Add tags"
                  />
                  <IconButton 
                    icon={MenuIcon} 
                    onClick={(e: any) => {
                      e.stopPropagation();
                      console.log('Assign to list:', footprint.id);
                    }}
                    title="Assign to list"
                  />
                  <IconButton 
                    icon={StarIcon} 
                    onClick={(e: any) => {
                      e.stopPropagation();
                      console.log('Toggle favorite:', footprint.id);
                    }}
                    title="Toggle favorite"
                  />
                  <IconButton 
                    icon={ArrowTopRightIcon} 
                    onClick={(e: any) => {
                      e.stopPropagation();
                      window.open(footprint.url, '_blank');
                    }}
                    title="Open in new tab"
                  />
                  <IconButton 
                    icon={TrashIcon} 
                    intent="danger" 
                    onClick={(e: any) => {
                      e.stopPropagation();
                      if (window.confirm('Are you sure you want to delete this footprint?')) {
                        deleteFootprint(footprint.id);
                      }
                    }}
                    title="Delete footprint"
                  />
                </div>
              </Table.TextCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}

export { Footprints };
